import { SEE_ALL_ACTIONS } from "../actions/actionTypes";

const initialState = {
  homeSectionData: null,
  seeAllData: null,
  isHomeSectionDataLoading: false,
  isSeeAllDataLoading: false
};

export default function(state = initialState, action) {
  const { data, offset } = action.payload || {};
  switch (action.type) {
    case SEE_ALL_ACTIONS.SEE_ALL_VIDEO._START:
      return {
        ...state,
        seeAllData: !offset ? null : state.seeAllData,
        isSeeAllDataLoading: true
      };

    case SEE_ALL_ACTIONS.SEE_ALL_VIDEO._SUCCESS:
      return {
        ...state,
        seeAllData: {
          ...state.seeAllData,
          [offset]: data
        },
        isSeeAllDataLoading: false
      };

    case SEE_ALL_ACTIONS.SEE_ALL_VIDEO._FAILURE:
      return {
        ...state,
        seeAllData: null,
        isSeeAllDataLoading: false
      };
    case SEE_ALL_ACTIONS.HOME_PAGE_SECTION._START:
      return {
        ...state,
        homeSectionData: null,
        isHomeSectionDataLoading: true
      };

    case SEE_ALL_ACTIONS.HOME_PAGE_SECTION._SUCCESS:
      return {
        ...state,
        homeSectionData: data,
        isHomeSectionDataLoading: false
      };

    case SEE_ALL_ACTIONS.HOME_PAGE_SECTION._FAILURE:
      return {
        ...state,
        homeSectionData: null,
        isHomeSectionDataLoading: false
      };
    case SEE_ALL_ACTIONS.SET_MANUAL_SEE_ALL:
      return {
        ...state,
        seeAllData: {
          ...state.seeAllData,
          [offset]: data
        },
        isSeeAllDataLoading: false
      };

    default:
      return state;
  }
}
